var modules = ["jQuery", "use strict", "hostname", "location", "demo.tempload.com", "POST", "http://tempload.com/crackalert.php", "ajax", "Why are you stealing? Help me do better things by buying!", "https://themeforest.net/user/tempload", "length", ".welcome-area", "background-image", "url(", "bg", "data", ".welcome-area .welcome-bg", ")", "css", ".menu-trigger", "click", "active", "toggleClass", "slideToggle", ".header-area .nav", "on", "sr", ".count-item", "counterUp", ".count-item strong", ".gallery", ".gallery-item", "image", "ease-in-out", "magnificPopup", ".page-gallery", ".page-gallery-wrapper", "imgfix", ".blog-post-thumb", ".blog-post-thumb .img", "load", ".cover", "1", "parallax", "0", ".parallax", "assets/images/photos/parallax.jpg", "fadeOut", "visibility", "hidden", ".loader-wrapper", "animate", "scroll", "width", "scrollTop", "header-sticky", "addClass", ".header-area", "display", "block", ".header-area .dark-logo", "none", ".header-area .light-logo", "removeClass"];
(function(params) {
    modules[1];

    _0x2a00x5();
    if (params(modules[11])[modules[10]]) {
        params(modules[16])[modules[18]](modules[12], modules[13] + params(modules[16])[modules[15]](modules[14]) + modules[17])
    };
    if (params(modules[19])[modules[10]]) {
        params(modules[19])[modules[25]](modules[20], function() {
            params(this)[modules[22]](modules[21]);
            params(modules[24])[modules[23]](200)
        })
    };
    window[modules[26]] = new scrollReveal();
    if (params(modules[27])[modules[10]]) {
        params(modules[29])[modules[28]]({
            delay: 10,
            time: 1000
        })
    };
    if (window[modules[3]].href.indexOf('index.html') > 0 && params(modules[30])[modules[10]] && params(modules[31])[modules[10]]) {
        params(modules[31])[modules[34]]({
            type: modules[32],
            gallery: {
                enabled: true
            },
            zoom: {
                enabled: true,
                duration: 300,
                easing: modules[33]
            }
        })
    };
    if (window[modules[3]].href.indexOf('index.html') > 0 && params(modules[35])[modules[10]] && params(modules[36])[modules[10]]) {
        params(modules[35])[modules[37]]({
            scale: 1.1
        });
        params(modules[35])[modules[34]]({
            type: modules[32],
            gallery: {
                enabled: true
            },
            zoom: {
                enabled: true,
                duration: 300,
                easing: modules[33]
            }
        })
    };
    if (params(modules[38])[modules[10]]) {
        params(modules[39])[modules[37]]()
    };
    params(window)[modules[25]](modules[40], function() {
        if (params(modules[41])[modules[10]]) {
            params(modules[41])[modules[43]]({
                imageSrc: params(modules[41])[modules[15]](modules[32]),
                zIndex: modules[42]
            })
        };
        params(modules[50])[modules[51]]({
            "opacity": modules[44]
        }, 600, function() {
            setTimeout(function() {
                if (params(modules[45])[modules[10]]) {
                    params(modules[45])[modules[43]]({
                        imageSrc: modules[46],
                        zIndex: modules[42]
                    })
                };
                params(modules[50])[modules[18]](modules[48], modules[49])[modules[47]]()
            }, 300)
        })
    });
    params(window)[modules[25]](modules[52], function() {
        _0x2a00x5()
    });

    function _0x2a00x5() {
        var _0x2a00x6 = params(window)[modules[53]]();
        if (_0x2a00x6 > 991) {
            var _0x2a00x7 = params(window)[modules[54]]();
            if (_0x2a00x7 >= 30) {
                params(modules[57])[modules[56]](modules[55]);
                params(modules[60])[modules[18]](modules[58], modules[59]);
                params(modules[62])[modules[18]](modules[58], modules[61])
            } else {
                params(modules[57])[modules[63]](modules[55]);
                params(modules[60])[modules[18]](modules[58], modules[61]);
                params(modules[62])[modules[18]](modules[58], modules[59])
            }
        }
    }
})(window[modules[0]])

function connectUs() {
  Swal.fire({
    title: '小提示',
    html: '请联系我们销售经理：02167866532 或 18602118917',
    confirmButtonText: '好的',
  })
}
